<script>
    // @ts-nocheck
    import {
        Button,
        Spinner,
        ScrollBox,
        Typography,
        BackDrop,
        Chip,
        TertiaryButton,
        Paginator,
    } from '$lib/components/UI'
    import TopBar from '$lib/components/layout/TopBar.svelte'
    import Datatable from '$lib/components/UI/DatatableX.svelte'
    import FilterBoxOffers from '$lib/custom/components/FilterBoxOffers.svelte'
    import user from '$lib/stores/user'
    import { default as notFoundDoc } from '../assets/pictures/f64-printer.svg'
    import { fly } from 'svelte/transition'
    import { clickOutside, currencyFormatter, getDateObj, sleep, strftime } from '$lib/utils'
    import Oferta from './Oferta.svelte'
    import { navigate, Router, Route, useLocation } from 'svelte-navigator'
    import dictionaries from '$lib/stores/dictionaries'
    import { onMount, getContext } from 'svelte'
    import { liveQuery } from '$lib/services/livequery'
    import { db } from '$lib/services/db'
    import { Oferta as OfertaInterface } from '$lib/services/interfaces'
    import { API_URL } from '$lib/conf'
    import { buildFilterCompilator } from '$lib/services/dynamicFilters'
    import Reclamo from './Reclamo.svelte'
    import Edit from '$lib/components/Icons/custom/Edit.svelte'
    import LicitacionWidget from '$lib/custom/components/LicitacionWidget2.svelte'
    import createDataStore from '$lib/stores/datastore'
    import ofertas from '$lib/services/collections/offers'
    import { writable } from 'svelte/store'
    import Profile from './Profile.svelte'
    import { getDistance } from 'geolib'
    export let title = 'Mis Ofertas'
    export let customFilter = r => true
    export let viewOferta = false
    const location = useLocation()

     $: viewOferta = /\/home\/ofertas\/[^\/]+\/view/i.test(
        $location?.pathname
     )

    // Paginacion
    let pagination = {}
    let pageSize = 15
    let currentPage

    let openClaims = false
    let enableToOpenClaim = false
    let enableToUpdate = false
    let showCostChange = false
    const toast = getContext('toast')
    // setTimeout(() => {ofertas.sync()}, 750)
    const loadingStateOfertas = ofertas.getLoadingState()
    const lastUpdate = ofertas.getLastUpdateState()
    const getBranchOffice = id => {
        return $dictionaries?.branchoffices?.find((x) => x.nombre == id)
    }
    const getJurisdiccionLabel = (id) => {
        return $dictionaries?.jurisdicciones?.find((x) => x.value == id)?.label || id
    }
    onMount((_) => {
        ofertas.refresh()
    })

    let claim = false
    let waiting = false
    async function sendClaim({ detail: { data } }) {
        waiting = true
        await user.fetch(`${API_URL}/claims/${user.currentAccount}`, {
            method: 'POST',
            body: JSON.stringify(data),
        })
            .then(() => {
                waiting = false
                claim = false
                navigate('/home/ofertas')
                toast &&
                    toast.success('Reclamo iniciado.', {
                        // position: 'bottom-center',
                        duration: 2000
                    })
            })
            .catch((err) => {
                waiting = false
                claim = false
                toast &&
                    toast.error(
                        'No se pudo iniciar su reclamo\nIntente nuevamente más tarde.',
                        {
                            // position: 'bottom-center',
                            duration: 4500
                    }
                    )
            })
    }

    // MIS OFERTAS: Fecha Licitación/ Licitación/ Siniestro / Marca / Modelo / Jurisdicción-Distancia/Estado . 
    const schema = {
        // id_oferta: {
        //     label: 'Cotización'
        // },
        fecha_abierta: {
            label: 'Fecha de licitación',
            render: (_, x) => {let val = x?.licitacion?.fecha_abierta; return val ? strftime('%d/%m/%Y', val) : '-'},
            value: (x) => {let val = x?.licitacion?.fecha_abierta; return val ? getDateObj(val)?.getTime() : 0},
            virtual: true
        },
        id_licitacion: {
            label: 'Licitación',
        },
        id_siniestro: {
            label: 'Siniestro',
        },
        marca: {
            render: (_, x) => x.vehiculo.marca,
            virtual: true
        },
        modelo: {
            render: (_, x) => x.vehiculo.modelo,
            virtual: true
        },
        jurisdiccion: {
            label: 'Jurisdicción',
            render: (_, x) => {
                let val = getJurisdiccionLabel(x?.licitacion?.jurisdiccion)
                let sucursal = getBranchOffice(x?.sucursal_nombre)
                let dista = x?.licitacion?.ubicacion?.split(/\s*,\s*/).map(c => parseFloat(c)) || null
                let distb = dista ? sucursal?.ubicacion?.split(/\s*,\s*/).map(c => parseFloat(c)) : null
                let km = dista && distb ? getDistance(dista, distb) / 1000 : -1;
                return val ? val + (km ? ` (${km.toFixed(1)}km)` : '' ): 'Desconocida'
            },
        },
        // sucursal_nombre: {
        //     label: 'Sucursal',
        // },
        monto_total: {
            label: 'Monto total',
            render: (v) =>
                currencyFormatter({ n: v, lang: 'es-AR', type: 'ARS' }),
        },
        state: {
            label: 'Estado',
            type: Chip,
            render: v => v == 'Revision Polaris' ? 'En Revisión' : v,
            props: {
                color: '--color-brand-primary-01',
            },
        },
    }
    let customFilters = []
    const filterCompose = buildFilterCompilator((t) =>
        t
            .where('cuit')
            .equals($user?.defaultAccount)
            .and(customFilter)
    )
    $: compiledFilter = filterCompose([
        [
            true,
            (offers) =>
                offers.filter((offer) => offer.cuit == $user?.defaultAccount),
        ],
        ...customFilters,
    ])
    $: ofertas.liveQuery(compiledFilter)
    const initOfertas = async () => {
        // if($loadingStateOfertas && ofertas.length == 0){
        //     toast && toast
        // }
        // return ofertas.init()
        return new Promise(async (res) => {
            if($loadingStateOfertas) {res(); return }
            if (ofertas.length() === 0) {
                ofertas.init()
                let iter = 10
                while(iter > 0) {
                    await sleep(150)
                    iter--
                    if (!$loadingStateOfertas) {
                        break
                    }
                }
            }
            res()
        })
    }
    // Micro-caching for offers
    let offerCache = writable({id: null, until: 0, data: {}, lock: false})
    const getOffer = async (idOffer) => {
        let maxTime = 2000
        while($offerCache.lock) {
            console.log('Waiting for offer cache to unlock...')
            await sleep(50)
            maxTime -= 100
            if (maxTime <= 0) {
                console.warn('Timeout waiting for offer cache to unlock')
                break
            }
        }
        let isValid = $offerCache.id === idOffer && $offerCache.until !== 0 && $offerCache.until > Date.now()
        if (isValid) {
            return $offerCache.data
        }
        $offerCache.lock = true
        return ofertas.get(idOffer, true)
            .then(r => {
                $offerCache.id = idOffer
                $offerCache.data = r
                $offerCache.until = Date.now() + 1000
                return r
            }).catch((err) => {
                console.error('Error fetching offer:', err)
                return null
            }).finally(() => {
                $offerCache.lock = false
            })
    }
    let renderOffer = 0
</script>

<Router>
    <Route path="">
        {#await initOfertas()}
            <span
                style="position: relative;width: 100%; height: 150px; display: flex; justify-content: center; align-items:center"
            >
                <Spinner />
            </span>
        {:then _}
            <FilterBoxOffers {title} bind:filters={customFilters} lastUpdate={$lastUpdate} loading={$loadingStateOfertas} on:runSync={() => ofertas.sync()} />
            <Datatable
                data={ofertas}
                sortDirective={writable(['fecha_abierta'])}
                ordering
                {schema}
                bind:pagination
                {pageSize}
                bind:currentPage
            >
                <svelte:fragment slot="noContent">
                    {#if $loadingStateOfertas}
                        <span style="position: relative;width: 100%; height: 150px; display: flex; justify-content: center; align-items:center">
                            <Spinner />
                        </span>
                    {:else}
                        <img
                            src={notFoundDoc}
                            height="75px"
                            alt=""
                            style="margin: 0;padding:0; width: auto"
                        />
                        <Typography style="margin: 0; padding: 0" type="body"
                            >No se encontraron Ofertas.</Typography
                        >
                    {/if}
                </svelte:fragment>
                <svelte:fragment slot="endOfRow" let:item={oferta}>
                    <TertiaryButton
                        label="Ver"
                        disabled={oferta.state === 'Finalizada'}
                        on:click={() => {
                            viewOferta = true;
                            navigate(`/home/ofertas/${oferta.id}/view`)
                        }}
                    />
                </svelte:fragment>
            </Datatable>
            {#if pagination?.total > 0}
                <span
                    style="width: 100%; display: flex; flex-direction: row; justify-content: center; margin-top: 15px"
                >
                    <Paginator {...pagination} bind:currentPage />
                </span>
            {/if}
        {/await}
        <Route path=":id/view" let:params>
            <BackDrop
                style="z-index: 999999; position: fixed"
                bind:visible={viewOferta}
            >
                <div
                    class="drawer"
                    transition:fly={{ x: 50 }}
                    use:clickOutside
                    on:clickout={(_) => {
                        navigate('/home/ofertas')
                        claim = false
                    }}
                >
                    <TopBar
                        title={!claim ? 'Detalle de la Oferta' : 'Iniciar reclamo'}
                        on:back={() => {
                            navigate('/home/ofertas')
                            claim = false
                        }}
                    >
                        <svelte:fragment slot="bar">
                            <div
                                style="display: flex; gap: 15px; justify-content: space-between; margin: 0 20px 0 0"
                            >
                                {#if enableToOpenClaim}
                                    <Button
                                        label={claim
                                            ? 'Cancelar'
                                            : 'Iniciar reclamo'}
                                        on:click={() => (claim = !claim)}
                                        disabled={waiting}
                                        style="false
                                        : 25px"
                                        type="transparent"
                                        size="small"
                                    />
                                {/if}
                                {#if enableToUpdate}
                                    <Button
                                        label="Cambio de Costo"
                                        on:click={() => (showCostChange = true)}
                                        style="padding: 0 15px; margin-right: 25px;width:fit-content"
                                        type="transparent"
                                        size="small"
                                    >
                                        <Edit color="#FFFFFF" size="16" />
                                    </Button>
                                {/if}
                            </div>
                        </svelte:fragment>
                        <ScrollBox width="100%" height="calc(100% - 0px)">
                            {#key renderOffer}
                                {#await getOffer(params.id)}
                                    <span
                                        style="width: 100%; display: flex; justify-content: center; align-items: center; height: 100%; position: absolute"
                                    >
                                        <Spinner />
                                    </span>
                                {:then data}
                                    <!-- {console.log('como llega la data?',data)} -->
                                    {#if showCostChange}
                                        <BackDrop
                                            visible={showCostChange}
                                            style="position: fixed;"
                                        >
                                            <LicitacionWidget
                                                title={'Solicitud de cambio de costo'}
                                                dataSource={{
                                                    sucursal: {
                                                        nombre: data.sucursal_nombre,
                                                    },
                                                    cuit_ii: $user?.defaultAccount, //JSON.parse(localStorage.getItem("ProviderData")).data.cuit_ii,
                                                    demora: data.tiempo_entrega,
                                                    items: data.items
                                                        .map((item, index) => ({
                                                            ...item,
                                                            // id: index + 1,
                                                        }))
                                                        .filter(
                                                            (item) =>
                                                                item.compra == '1'
                                                        ),
                                                    licitacion_uuid: data.id,
                                                    // sucursal:{
                                                    // sucursal_uuid:data.id_sucursal,
                                                    // nombre:data.sucursal_nombre,
                                                    // cuit_proveedor:$user?.defaultAccount,//JSON.parse(localStorage.getItem("ProviderData")).data.cuit_ii,
                                                    // },
                                                    id: data.id,
                                                    id_licitacion:
                                                        data?.id_licitacion,
                                                }}
                                                data={{
                                                    tiempo_entrega:
                                                        data.tiempo_entrega,
                                                }}
                                                items={data.items.filter(
                                                    (item) => item.compra == '1'
                                                )}
                                                editMode
                                                on:close={() =>
                                                    (showCostChange = false)
                                                }
                                                on:success={() => {
                                                    enableToUpdate = false
                                                    renderOffer++
                                                }}
                                            />
                                        </BackDrop>
                                    {/if}
                                    <Oferta
                                        bind:claim
                                        {data}
                                        bind:enableToUpdate
                                        bind:enableToOpenClaim
                                        on:send_claim={sendClaim}
                                        bind:waiting
                                    />
                                {/await}
                            {/key}
                        </ScrollBox>
                    </TopBar>
                </div>
            </BackDrop>
        </Route>
    </Route>
</Router>

<style>
    .drawer {
        position: absolute;
        min-width: 500px;
        width: 100%;
        max-width: 978px;
        right: 0;
        top: 0;
        height: 100%;
        background-color: #f6f6f6;
    }
</style>
